import { useRef, useState } from "react";
import { sanitizeHTML } from "../../helper/SanitizeHTML";
const Reviews = ({ reviews }) => {
  const book_review = useRef();
  const [review, setReview] = useState(book_review);
  const [show, setShow] = useState(false);
  const handleShowHide = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="container-fluid author_reviews">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 reviews_main_container">
            <div className="container">
              <div className="row">
                <p className="reviews_heading pull-left">Reviews</p>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 review_description">
                  <div className="row book_reviews">
                    <div
                      className={
                        show || review.offsetHeight < 160
                          ? "review1"
                          : "review1 review1_height"
                      }
                    >
                      <div
                        className={
                          show || review.offsetHeight < 160
                            ? "review2"
                            : "review2 review2_height"
                        }
                        style={{ paddingBottom: "20px" }}
                      >
                        <p ref={(el) => setReview(el)}>
                          <span
                            dangerouslySetInnerHTML={sanitizeHTML(reviews)}
                          />
                        </p>
                        {!show && review.offsetHeight > 160 && (
                          <div className="fadeBook"></div>
                        )}
                      </div>
                      {review.offsetHeight > 160 && (
                        <div
                          className={`review_show_more toggle_show_more_text ${
                            !show && "review_show_more_fade"
                          }`}
                          style={{
                            position: show
                              ? "static !important"
                              : "absolute !important",
                          }}
                        >
                          <span
                            rel={show ? 1 : 0}
                            style={{ cursor: "pointer" }}
                            className="showmoretxt pull-left"
                            onClick={handleShowHide}
                          >
                            {!show ? "Show More" : "Less"}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reviews;
